import { CloseCircleFilled } from "@ant-design/icons"
import { useNotification } from "components/Notification/Notification"
import { useEffect, useState } from "react"
import { getBase64 } from "utils/file"
import { Image } from "./Image"

export function ImageThumbnail({
	file,
	disabled,
	onRemove,
}: {
	file: File
	disabled: boolean
	onRemove: VoidFunction
}) {
	const { notify } = useNotification()
	const [src, setSrc] = useState<string>()

	useEffect(() => {
		async function loadBase64() {
			const result = await getBase64(file)
			setSrc(result as string)
		}
		loadBase64()
	}, [file])

	if (!src) {
		return null
	}

	return (
		<div className="relative flex size-10 rounded-lg outline-green-20 focus:outline-2">
			<Image
				src={src}
				rootClassName="aspect-square rounded-md"
				className="rounded-lg object-cover text-[6px]"
				alt={`Image ${file.name} ready to be sent`}
				preview
				onError={() => notify.error({ message: "Not a valid image" })}
			/>

			{!disabled && (
				<CloseCircleFilled
					tabIndex={0}
					role="button"
					aria-label={`Remove image ${file.name}`}
					className="absolute -top-1 -right-1 size-4 place-content-center rounded-full bg-white outline-green-20 hover:cursor-pointer"
					onClick={onRemove}
					onKeyDown={(e) => {
						if (e.key === "Enter" || e.key === " ") {
							onRemove()
						}
					}}
				/>
			)}
		</div>
	)
}
